import { Route, Routes } from "react-router-dom";

import {LinkedExternalAcctLink } from "../../pages";

export const LinkedAccountLayout = () =>{
  return (
    <Routes>
    <Route path="/" element={<LinkedExternalAcctLink/>} />
  </Routes>
  )
}

    
  
